import { ContextMenuType } from 'interfaces'
import { createContext, useCallback, useState } from 'react'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
const fullNameCookies = cookies.get('fullName') as string
const organizationLogoCookies = cookies.get('organization_logo') as string

const MenuContextDefaultValue: ContextMenuType = {
	fullName: fullNameCookies,
	sidebarOpen: true,
	organizationLogo: organizationLogoCookies,
	setFullName: () => null,
	setSidebarOpen: () => null,
	setOrganizationLogo: () => null
}
export const MenuContext = createContext<ContextMenuType>(
	MenuContextDefaultValue
)
export const useContextMenu = (): ContextMenuType => {
	const [sidebarOpen, setSidebarOpenValue] = useState<boolean>(
		MenuContextDefaultValue.sidebarOpen
	)

	const [fullName, setFullNameValue] = useState<string>(
		MenuContextDefaultValue.fullName
	)

	const [organizationLogo, setOrganizationLogoValue] = useState<string>(
		MenuContextDefaultValue.organizationLogo
	)

	const setSidebarOpen = useCallback(
		(value: boolean) => {
			setSidebarOpenValue(value)
		},
		[setSidebarOpenValue]
	)

	const setFullName = useCallback(
		(value: string) => {
			setFullNameValue(value)
		},
		[setFullNameValue]
	)

	const setOrganizationLogo = useCallback(
		(value: string) => {
			setOrganizationLogoValue(value)
		},
		[setOrganizationLogoValue]
	)

	return {
		fullName,
		setFullName,
		sidebarOpen,
		setSidebarOpen,
		organizationLogo,
		setOrganizationLogo
	}
}
